import React from "react";
import { createPortal } from "react-dom";
import ImpersonateVendorButton from "./ImpersonateVendorButton";
import { IconClose, IconExternalLink, IconInstagram, IconFacebook } from "./VendorIcons";
import "./VendorDetailsModal.css";

// Helper function to format ISO timestamps cleanly
const formatSubmittedDate = (dateString) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "—";

  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const VendorDetailsModal = ({ vendor = {}, application = {}, instagram, facebook, onClose }) => {
  // Uses created_at directly from vendor_applications schema
  const submittedAt = application.created_at;

  return createPortal(
    <div className="vdm-overlay" onClick={onClose}>
      <div
        className="vdm-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={`${vendor.brand_name || "Vendor"} details`}
      >
        <div className="vdm-header">
          <div>
            <h3 className="vdm-title">{vendor.brand_name || "Unnamed vendor"}</h3>
            <span className="vdm-submitted-meta">
              Submitted {formatSubmittedDate(submittedAt)}
            </span>
          </div>
          <button className="vdm-close" onClick={onClose} aria-label="Close">
            <IconClose width={18} height={18} />
          </button>
        </div>

        <div className="vdm-body">
          <section className="vdm-section">
            <h4 className="vdm-section-heading">About</h4>
            <p className="vdm-description">{application.description || "No description provided."}</p>
          </section>

          <section className="vdm-section">
            <h4 className="vdm-section-heading">Application & Contact Details</h4>
            <dl className="vdm-detail-list">
              <div className="vdm-detail-row">
                <dt>Date Submitted</dt>
                <dd>{formatSubmittedDate(submittedAt)}</dd>
              </div>
              <div className="vdm-detail-row">
                <dt>Contact person</dt>
                <dd>{vendor.contact_person || "—"}</dd>
              </div>
              <div className="vdm-detail-row">
                <dt>Email</dt>
                <dd>{vendor.email || "—"}</dd>
              </div>
              <div className="vdm-detail-row">
                <dt>Phone</dt>
                <dd>{vendor.phone_number || "—"}</dd>
              </div>
              <div className="vdm-detail-row">
                <dt>WhatsApp</dt>
                <dd>{application.whatsapp_number || "—"}</dd>
              </div>
              <div className="vdm-detail-row">
                <dt>Location</dt>
                <dd>{application.location || "—"}</dd>
              </div>
            </dl>
          </section>

          {(vendor.website || instagram || facebook) && (
            <section className="vdm-section">
              <h4 className="vdm-section-heading">Online</h4>
              <div className="vdm-links">
                {vendor.website && (
                  <a className="vdm-link" href={vendor.website} target="_blank" rel="noreferrer">
                    <IconExternalLink />
                    {vendor.website.replace(/^https?:\/\//, "")}
                  </a>
                )}
                {instagram && (
                  <a className="vdm-link" href={`https://instagram.com/${instagram}`} target="_blank" rel="noreferrer">
                    <IconInstagram />
                    @{instagram}
                  </a>
                )}
                {facebook && (
                  <a className="vdm-link" href={`https://facebook.com/${facebook}`} target="_blank" rel="noreferrer">
                    <IconFacebook />
                    {facebook}
                  </a>
                )}
              </div>
            </section>
          )}

          <section className="vdm-section">
            <h4 className="vdm-section-heading">Admin tools</h4>
            <div className="vdm-admin-tools">
              <ImpersonateVendorButton vendorId={vendor.id} />
            </div>
          </section>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default VendorDetailsModal;